import { BottomSheet, Button, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { View } from 'react-native';
import { content } from './CountryOfTaxResidenceModal.content';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';

const CountryOfTaxResidenceModal = ({
  isOpen,
  onAccept,
  onReject,
  loading,
}: {
  isOpen: boolean;
  onAccept: () => void;
  onReject: () => void;
  loading: boolean;
}) => {
  const localizedContent = useContent(content);
  return (
    <DialogOrBottomSheet
      dismissable={false}
      blurEnabled={true}
      isOpen={isOpen}
      footerContent={
        <View className="flex flex-col gap-4 p-4">
          <Button
            size="large"
            color="primary"
            text={localizedContent.yes}
            onPress={onAccept}
            loading={loading}
          />
          <Button
            size="large"
            color="secondary"
            text={localizedContent.no}
            onPress={onReject}
          />
        </View>
      }
      backgroundColor="#0C1C2C">
      <View className="w-full flex flex-col items-center gap-4 p-4">
        <Heading level={4} className="text-center">
          {localizedContent.title}
        </Heading>
        <Typography size="large" className="text-center">
          {localizedContent.description}
        </Typography>
      </View>
    </DialogOrBottomSheet>
  );
};

export default CountryOfTaxResidenceModal;
